import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { theme } from "../../theme";

const TwitterSvg = ({ fill = theme.colors.navigation.string() }) => (
  <svg
    width="2em"
    height="2em"
    viewBox="0 0 34 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34 3.31481C32.7491 3.87756 31.4047 4.25656 29.9937 4.4274C31.4344 3.55312 32.5408 2.16776 33.0607 0.516817C31.7135 1.3265 30.2203 1.91509 28.6308 2.23236C27.3601 0.858491 25.5453 0 23.5393 0C19.0357 0 15.7264 4.258 16.7436 8.67822C10.948 8.38392 5.80833 5.57014 2.36725 1.29348C0.53975 4.47047 1.4195 8.62654 4.52483 10.7311C3.383 10.6938 2.30633 10.3765 1.36708 9.8468C1.29058 13.1214 3.60683 16.185 6.9615 16.8669C5.97975 17.1368 4.9045 17.2 3.81083 16.9875C4.69767 19.7955 7.27317 21.8384 10.3275 21.8958C7.395 24.2258 3.70033 25.2666 0 24.8244C3.08692 26.83 6.75467 28 10.693 28C23.6442 28 30.9612 16.9157 30.5192 6.97416C31.8821 5.97641 33.065 4.73175 34 3.31481Z"
      fill={fill}
    />
  </svg>
);

const FacebookSvg = ({ fill = theme.colors.navigation.string() }) => (
  <svg
    width="2em"
    height="2em"
    viewBox="-8 0 30 30"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      fill={fill}
      d="M3.026,5.81033333 L3.026,9.94066667 L0,9.94066667 L0,14.9913333 L3.026,14.9913333 L3.026,30 L9.242,30 L9.242,14.9916667 L13.4133333,14.9916667 C13.4133333,14.9916667 13.804,12.57 13.9933333,9.922 L9.26566667,9.922 L9.26566667,6.46866667 C9.26566667,5.95266667 9.94333333,5.25833333 10.6133333,5.25833333 L14,5.25833333 L14,0.000333333333 L9.39533333,0.000333333333 C2.87233333,2.96041403e-16 3.026,5.05566667 3.026,5.81033333"
    />
  </svg>
);

const YouTubeSvg = ({ fill = theme.colors.navigation.string() }) => (
  <svg height="2em" viewBox="0 -43 512 512" width="2em">
    <path
      fill={fill}
      d="m450.644531 23.011719-28.628906-5.921875c-110.164063-22.785156-221.867187-22.785156-332.03125 0l-28.628906 5.921875c-35.550781 7.34375-61.355469 39.03125-61.355469 75.339843v229.929688c0 36.308594 25.804688 67.992188 61.355469 75.339844l28.628906 5.921875c55.082031 11.394531 110.550781 17.09375 166.015625 17.09375s110.933594-5.699219 166.015625-17.09375l28.628906-5.921875c35.558594-7.347656 61.355469-39.03125 61.355469-75.339844v-229.929688c0-36.308593-25.804688-67.984374-61.355469-75.339843zm-88.363281 208.007812-152.0625 89.855469c-3.269531 1.929688-6.859375 2.890625-10.460938 2.890625-3.5 0-6.988281-.902344-10.191406-2.730469-6.492187-3.710937-10.375-10.382812-10.375-17.867187v-179.703125c0-7.484375 3.882813-14.15625 10.375-17.867188 6.503906-3.707031 14.21875-3.644531 20.652344.167969l152.054688 89.839844c6.324218 3.738281 10.105468 10.359375 10.105468 17.707031s-3.773437 13.976562-10.097656 17.707031zm0 0"
    />
  </svg>
);

const InstagramSvg = ({ fill = theme.colors.navigation.string() }) => (
  <svg
    width="2em"
    height="2em"
    viewBox="0 0 30 30"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      fill={fill}
      d="M29.91,8.81666667 C29.8853105,7.57212335 29.6497489,6.34077834 29.2133333,5.175 C28.8362071,4.17403658 28.2452441,3.26740039 27.4816667,2.51833333 C26.7325996,1.75475589 25.8259634,1.1637929 24.825,0.786666667 C23.6597478,0.350436026 22.4289819,0.114877363 21.185,0.09 C19.5833333,0.0166666667 19.0733333,0 15,0 C10.9266667,0 10.4166667,0.0166666667 8.81666667,0.09 C7.57212335,0.114689488 6.34077834,0.350251142 5.175,0.786666667 C4.17344035,1.1635783 3.26621636,1.75455368 2.51666667,2.51833333 C1.75308922,3.26740039 1.16212624,4.17403658 0.785,5.175 C0.348769359,6.34025223 0.113210696,7.57101807 0.0883333333,8.815 C0.0166666667,10.4166667 0,10.9266667 0,15 C0,19.0733333 0.0166666667,19.5833333 0.09,21.1833333 C0.114689488,22.4278767 0.350251142,23.6592217 0.786666667,24.825 C1.1637929,25.8259634 1.75475589,26.7325996 2.51833333,27.4816667 C3.26736626,28.2452858 4.17401223,28.8362551 5.175,29.2133333 C6.34025223,29.649564 7.57101807,29.8851226 8.815,29.91 C10.4166667,29.9833333 10.9266667,30 15,30 C19.0733333,30 19.5833333,29.9833333 21.1833333,29.91 C22.4278767,29.8853105 23.6592217,29.6497489 24.825,29.2133333 C26.8406744,28.4340909 28.4340909,26.8406744 29.2133333,24.825 C29.649564,23.6597478 29.8851226,22.4289819 29.91,21.185 C29.9833333,19.5833333 30,19.0733333 30,15 C30,10.9266667 29.9833333,10.4166667 29.91,8.81666667 Z M27.21,21.0616667 C27.1985005,22.0121922 27.0237348,22.9536718 26.6933333,23.845 C26.1891778,25.1537909 25.1551623,26.1884119 23.8466667,26.6933333 C22.9548037,27.0238905 22.0127497,27.1986581 21.0616667,27.21 C19.4783333,27.2816667 19.005,27.2966667 15,27.2966667 C10.995,27.2966667 10.52,27.2816667 8.93833333,27.21 C7.98781106,27.1984675 7.04633698,27.0237028 6.155,26.6933333 C5.50280627,26.4532722 4.91276662,26.0699742 4.42833333,25.5716667 C3.93023365,25.0877135 3.54694879,24.4982635 3.30666667,23.8466667 C2.9760775,22.9548125 2.80130882,22.012753 2.79,21.0616667 C2.71833333,19.4783333 2.70333333,19.005 2.70333333,15 C2.70333333,10.995 2.71833333,10.52 2.79,8.93833333 C2.80153255,7.98781106 2.9762972,7.04633698 3.30666667,6.155 C3.54672782,5.50280627 3.93002578,4.91276662 4.42833333,4.42833333 C4.9122865,3.93023365 5.50173648,3.54694879 6.15333333,3.30666667 C7.04519633,2.97610952 7.98725027,2.80134188 8.93833333,2.79 C10.5216667,2.71833333 10.995,2.70333333 15,2.70333333 C19.005,2.70333333 19.48,2.71833333 21.0616667,2.79 C22.0121889,2.80153255 22.953663,2.9762972 23.845,3.30666667 C24.4971937,3.54672782 25.0872334,3.93002578 25.5716667,4.42833333 C26.0697663,4.9122865 26.4530512,5.50173648 26.6933333,6.15333333 C27.0238905,7.04519633 27.1986581,7.98725027 27.21,8.93833333 C27.2816667,10.5216667 27.2966667,10.995 27.2966667,15 C27.2966667,19.005 27.2816667,19.48 27.21,21.0616667 Z M15,7.29666667 C10.7455665,7.29666667 7.29666667,10.7455665 7.29666667,15 C7.29666667,19.2544335 10.7455665,22.7033333 15,22.7033333 C19.2544335,22.7033333 22.7033333,19.2544335 22.7033333,15 C22.7033333,12.956949 21.8917345,10.997576 20.4470792,9.55292076 C19.002424,8.10826553 17.043051,7.29666667 15,7.29666667 Z M15,20 C12.2385763,20 10,17.7614237 10,15 C10,12.2385763 12.2385763,10 15,10 C17.7614237,10 20,12.2385763 20,15 C20,17.7614237 17.7614237,20 15,20 Z M24.8066667,6.99333333 C24.8066667,7.98744588 24.0007792,8.79333333 23.0066667,8.79333333 C22.0125541,8.79333333 21.2066667,7.98744588 21.2066667,6.99333333 C21.2066667,5.99922078 22.0125541,5.19333333 23.0066667,5.19333333 C24.0007792,5.19333333 24.8066667,5.99922078 24.8066667,6.99333333 Z"
    />
  </svg>
);

const Circle = styled(motion.a)`
  width: 3em;
  height: 3em;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const buttonVariants = {
  closed: {
    rotate: 0,
    transition: {
      rotate: { stiffness: 1000, velocity: -100 }
    }
  },
  open: {
    rotate: -90,
    transition: {
      rotate: { stiffness: 1000 },
      delay: 0.1
    }
  }
};

const SocialLink = Component => ({ to, children, ...rest }) => (
  <Circle
    href={to}
    target={"_blank"}
    {...rest}
    variants={buttonVariants}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
  >
    <Component />
  </Circle>
);

export const TwitterLink = SocialLink(TwitterSvg);
export const FacebookLink = SocialLink(FacebookSvg);
export const YouTubeLink = SocialLink(YouTubeSvg);
export const InstagramLink = SocialLink(InstagramSvg);
